export default "__VITE_ASSET__DwgbfKGm__"